// Spinner component that displays animated or static ring with children centered

const Spinner = ({
  children,
  size,
}: {
  children?: React.ReactNode
  size: number
}) => {
  const ringWidth = Math.max(2, Math.round(size * 0.06))

  return (
    <div
      className="relative overflow-hidden rounded-full"
      style={{
        width: size,
        height: size,
        boxShadow: `0 0 0 ${ringWidth}px hsl(var(--brand))`,
      }}
    >
      <img
        className="absolute inset-0 h-full w-full scale-115 rounded-full"
        alt=""
        width={512}
        height={512}
        src="/gif/spinner-white-on-black.gif"
      />
      <div className="text-brand absolute inset-0 z-10 flex items-center justify-center">
        {children}
      </div>
    </div>
  )
}

export default Spinner
